import React, { useEffect, useState } from "react";
import styles from "./desktop.module.scss";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectCoverflow } from "swiper/modules";
import { Rating } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
// import { useRouter } from "next/router";
// import { handleStartLearningEvent } from "../../../../../utils/helperEventFunctions";
// import { Context } from "../../../../../store";
import { handleGetVideoDataBySlug } from "../../../../../utils/constants/videoDetails";
import useRouting from "../../../../../hooks/useRouting";
import ScreenReaderOnly from "../../Common/ScreenReaderOnly";
import CustomNextImage from "../../Common/CustomNextImage";
import BlurredBG from "../../Icons/LandingPage/BlurredBG";
// import useStore from "../../../../../store/UseStore";
import DownloadTheAppCTA from "../../Common/DownloadTheAppCTA";
// import Image from "next/image";
// import { faAppStore, faGooglePlay } from "@fortawesome/free-brands-svg-icons";
// import PlayStoreLogo from "../../../../Icons/PlayStoreLogo";
// import AppStoreLogo from "../../../../Icons/AppStoreLogo";

const Desktop = ({ heroSectionData }) => {
  // const { userData } = useStore();
  // const globalState = useContext(Context);
  const [series_list, setSeriesList] = useState([]);
  const background_image = heroSectionData?.background_image;
  const { routeToSeries } = useRouting();
  // const router = useRouter();
  // const firebase_uid = globalState?.user?.uid;
  // const isCurrentUserPremium = userData?.is_premium;

  // const handleRedirect = () => {
  //   handleStartLearningEvent({
  //     firebase_uid,
  //     source_screen: router.pathname,
  //     status: userData?.phone ? "LoggedIn User" : "LoggedOut User",
  //     webviewEvent: webViewEventState,
  //   });
  //   if (!userData?.phone) {
  //     router.push("/login");
  //   } else if (!isCurrentUserPremium) {
  //     router.push("/premium");
  //   } else {
  //     window.location.href = "/app";
  //   }
  // };

  const handleRedirectToSeries = (data) => {
    routeToSeries({ slug: data?.slug, seriesId: data?.id });
  };

  useEffect(() => {
    setSeriesList(heroSectionData?.series_list);
  }, [heroSectionData]);

  return (
    <div className={styles.desktop_main_container}>
      <div className={styles.content_container}>
        <div className={styles.left_section}>
          <h1 className={styles.description}>
            <span className="text-[#FFC632]">
              {heroSectionData?.description?.split("|")[0]}{" "}
            </span>
            {heroSectionData?.description?.split("|")[1]}
          </h1>

          {/* <div className={styles.ratings_download_container}>
            <Rating
              className={styles.rating_stars}
              name="half-rating-read"
              defaultValue={4.5}
              precision={0.1}
              readOnly
              icon={
                <FontAwesomeIcon
                  icon={faStar}
                  style={{ fontSize: 14, marginLeft: 4 }}
                />
              }
              emptyIcon={
                <FontAwesomeIcon
                  icon={faStar}
                  style={{ color: "rgba(0,0,0,0)" }}
                />
              }
            />
            <div style={{ display: "flex", gap: "10px" }}>
              <h6 className={styles.downloads}>
                {heroSectionData?.downloads || "5 Millions +"}
              </h6>
              <FontAwesomeIcon icon={faDownload} style={{ color: "gray" }} />
            </div>
            <Image
              src="/assets/landing/logos_google.webp"
              width={106}
              height={5}
              alt="GooglePlay"
              className={styles.googlePlay_icon}
            />
          </div> */}

          {/* <div className={styles.scan_code_container}>
            <div className={styles.scanner_text}>
              <h6>Scan to Download</h6>
              <h6
                onClick={() => {
                  window.location.href = GooglePlayRedirectUrl;
                }}
                style={{ cursor: "pointer" }}
                className="underline"
              >
                Download the app
              </h6>
              <h6 className={styles.trusted_title}>
                {heroSectionData?.trusted_title}
              </h6>
            </div>
            <img
              src="/assets/landing/heroSection/PlayStoreQR.png"
              alt="GooglePlay"
              className={styles.googlePlay_QR}
            />
          </div> */}

          {/* <div className="mt-5">
            <button
              className="bg-white text-black px-10 py-3 rounded-full flex gap-x-5 items-center"
              onClick={handleRedirect}
            >
              Start Learning
              <FontAwesomeIcon
                icon={faArrowRight}
                style={{ color: "black" }}
                className={styles.bounce_download}
              />
            </button>
          </div> */}
          <div className="mt-3">
            <DownloadTheAppCTA
              animate
              onSection="Hero Desktop"
              className="w-[27%]"
            />
            <h6 className="text-[25px] font-normal tracking-wide mt-4">
              Trusted by 1Cr+ Indians
            </h6>
            <div className="mt-3">
              <Rating
                className={styles.rating_stars}
                name="half-rating-read"
                defaultValue={4.5}
                precision={0.1}
                readOnly
                icon={
                  <FontAwesomeIcon
                    icon={faStar}
                    style={{ fontSize: 20, marginLeft: 4 }}
                  />
                }
                emptyIcon={
                  <FontAwesomeIcon
                    icon={faStar}
                    style={{ color: "rgba(0,0,0,0)" }}
                  />
                }
              />
            </div>
            {/* <div className="flex w-fit gap-x-3 mt-2">
              <PlayStoreLogo className="w-[120px]" />
              <AppStoreLogo className="w-[120px]" />
            </div> */}
          </div>

          <BlurredBG className={styles.blurred_prop_1} />
        </div>

        {/* Right Section */}
        <div className={styles.right_section}>
          <img
            src={background_image}
            alt="MobileScreenImage"
            className={styles.mobile_screen_image}
          />
          <div className={styles.series_container}>
            <div className="my_slider_scrollbar">
              <Swiper
                loop={true}
                slidesPerView={"auto"}
                initialSlide={1}
                navigation={false}
                effect="coverflow"
                coverflowEffect={{
                  rotate: 0,
                  stretch: 100,
                  depth: 150,
                  modifier: 3,
                  slideShadows: true,
                }}
                modules={[EffectCoverflow, Pagination]}
                style={{
                  height: "100%",
                }}
              >
                {[...Array(1)]
                  .flatMap(() => series_list ?? [])
                  .map((data, index) => {
                    return (
                      <SwiperSlide key={index} style={{ height: "100%" }}>
                        <ScreenReaderOnly content={data?.description} />
                        <a
                          href={`${
                            handleGetVideoDataBySlug({ slug: data?.slug })
                              ? `/details/${data?.slug}`
                              : `/video/${data?.slug}`
                          }`}
                        >
                          <CustomNextImage
                            src={data?.image}
                            alt="seekho"
                            width={180}
                            height={260}
                            className={`${styles.img_card} img_card_custom cursor-pointer`}
                            priority={true}
                            onClick={() => handleRedirectToSeries(data)}
                          />
                        </a>
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Desktop;
